import {
  wrap,
  item,
  input,
  label,
} from './style'
import { Spacer } from 'components/Spacer'
import { Subtitle02 } from 'components/Typography/Subtitle02'
import { Text03 } from 'components/Typography/Text03'
import { CameraSettingsProps } from 'types'
import { Color } from 'utils/variables'

export const CameraSettings = ({ videoDevices, onChange }: CameraSettingsProps) => {
  return (
    <>
      <Text03 color={Color.WarmGrey}>カメラ</Text03>
      <Spacer size={13} />
      <div className={wrap}>
        {videoDevices.map(({ text, value, checked }) => (
          <div key={value} className={item}>
            <input
              id={value}
              type="radio"
              name="videoDevices"
              value={value}
              checked={checked}
              onChange={onChange}
              className={input}
            />
            <label
              htmlFor={value}
              className={label}
            >
              <Subtitle02 color={Color.LightBlack}>
                {text}
              </Subtitle02>
            </label>
          </div>
        ))}
      </div>
    </>
  );
}

